import { chooseErrorMessage } from 'shared/utils/errorHandling';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { reportContract } from 'shared/domain/report/reportContract';
import { makeErrorPublisher, makeEventPublisher } from 'serviceWorker/broadcasts/publishers';

export const broadcastReportCreated = makeEventPublisher(reportContract, DomainMessagesTypes.createdEntity);

const publishReportError = makeErrorPublisher(reportContract);

/**
 * A failed report is its `createdEntity` with `error`, the report request's
 * `uniqueId` and the server's `messageId`, so the page's command rejects with it.
 */
export function broadcastCreateReportError(
  error: unknown,
  uniqueId?: string,
  data?: unknown
): void {
  publishReportError(DomainMessagesTypes.createdEntity, error, {
    uniqueId,
    data,
    messageId: chooseErrorMessage(error),
  });
}
